import { IDisplayTableModel } from '../models/display-table-model'

export class DisplayTableView {
  constructor(private dispalyTableModelAry: IDisplayTableModel[]) {}

  public getDispalyTableModelAry(): IDisplayTableModel[] {
    return this.dispalyTableModelAry
  }
}
